import { useEffect, useState } from "react";
import { CalendarOff } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export function UnscheduledAssignmentsPanel() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/connecteam/unscheduled-assignments").then((r) => setData(r.data)).catch((e) => setError(formatApiError(e)));
  }, []);
  if (error) return <p className="form-message error-message" data-testid="unscheduled-error">{error}</p>;
  if (!data) return null;
  return (
    <section className="connecteam-panel" data-testid="connecteam-unscheduled">
      <div className="section-heading">
        <div>
          <h2><CalendarOff size={17} /> Assignments with no Connecteam schedule ({data.count})</h2>
          <p>Live client assignments with no published shifts at that client in the last week or next {data.window_days} days. The client team page is built from the Connecteam schedule plus open evaluations, so these people only appear there if they hold an open evaluation. {data.checked} live assignments checked.</p>
        </div>
      </div>
      <div className="requests-table-panel">
        <table className="requests-table connecteam-table" data-testid="unscheduled-table">
          <thead><tr><th>Person</th><th>Client</th><th>Assignment</th><th>Dates</th><th>Why it's missing</th><th>On team page?</th></tr></thead>
          <tbody>
            {data.assignments.map((row) => (
              <tr key={row.id} data-testid={`unscheduled-row-${row.id}`}>
                <td><strong>{row.assigned_person_name}</strong></td>
                <td>{row.client_name}</td>
                <td>{row.role_label || "—"}<br /><small className="pairing-meta">{row.request_id}{row.record_keeping ? " · record-keeping" : ""} · {row.status}</small></td>
                <td>{row.start_date || "—"}{row.end_date ? ` — ${row.end_date}` : ""}</td>
                <td>{row.reason}</td>
                <td>{row.shown_on_team_page ? <span className="status-chip status-active">Yes · open evaluation</span> : <span className="status-chip status-pending">No</span>}</td>
              </tr>
            ))}
            {!data.assignments.length && <tr><td colSpan={6} className="provider-empty-state" data-testid="unscheduled-empty">Every live client assignment has a published Connecteam schedule.</td></tr>}
          </tbody>
        </table>
      </div>
      <div className="section-heading" style={{ marginTop: 20 }}>
        <div>
          <h3 data-testid="unlinked-heading">Scheduled in Connecteam, not linked in TAGForce ({data.unlinked_count})</h3>
          <p>People with published shifts at a mapped client who are not linked to any TAGForce provider. Clients never see them until they are added or mapped.</p>
        </div>
      </div>
      <div className="requests-table-panel">
        <table className="requests-table connecteam-table" data-testid="unlinked-table">
          <thead><tr><th>Connecteam user</th><th>Title</th><th>Client</th><th>Published shifts</th><th>What to do</th></tr></thead>
          <tbody>
            {data.unlinked.map((row) => (
              <tr key={`${row.connecteam_user_id}-${row.client_id}`} data-testid={`unlinked-row-${row.connecteam_user_id}-${row.client_id}`}>
                <td><strong>{row.name}</strong><br /><small className="pairing-meta">Connecteam #{row.connecteam_user_id}</small></td>
                <td>{row.title || "—"}</td>
                <td>{row.client_name}</td>
                <td>{row.shifts}</td>
                <td>{row.reason}</td>
              </tr>
            ))}
            {!data.unlinked.length && <tr><td colSpan={5} className="provider-empty-state" data-testid="unlinked-empty">Everyone scheduled at a mapped client is linked to a TAGForce provider.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
